module.exports = __webpack_public_path__ + "static/media/esnLogo512.d4a61a5e.png";